import { client, withDataRequest } from 'utils/client';
import { CalendarEventForm, DownloadCalendaForm, CalendarEventFormData, CalendarEventAuthData, CalendarEventAuthUrlData, DownloadCalendaFormData } from 'features/calendar-events/types';

const calendarEventsAPI = {
  createGoogleCalendarEventForJobSeeker<T extends object>(data: CalendarEventForm<T>) {
    return client.post<CalendarEventFormData>('/calendar-events/google/create-event-for-job-seeker', withDataRequest(data));
  },
  getGoogleCalendarAuthUrl() {
    return client.get<CalendarEventAuthUrlData>('/calendar-events/google/get-auth-url');
  },
  authGoogleCalendarForJobSeeker(code: string) {
    return client.get<CalendarEventAuthData>(`/calendar-events/google/auth-for-job-seeker?code=${code}`);
  },
  downloadGoogleCalendarEventsForJobSeeker(data: DownloadCalendaForm) {
    return client.post<DownloadCalendaFormData>('/calendar-events/google/download-for-job-seeker', withDataRequest(data));
  },
};

export default calendarEventsAPI;
